import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, ICardDtoCardStatusEnum } from '@/dtos';

const useActivateCardByIdQuery = () => {
  const { mutateAsync, isLoading, isError, isSuccess } = useMutation((cardId: string) =>
    api.put(API_URL.CARDS_BY_CARD_ID(cardId), {
      status: ICardDtoCardStatusEnum.ACTIVE,
    })
  );

  return {
    onActivateCardById: mutateAsync,
    isCardActivationLoading: isLoading,
    isSuccess,
    isError,
  };
};

export default useActivateCardByIdQuery;
